/**
 * Site-wide configuration.
 * Centralises copy, routes and metadata so Figma-driven pages stay
 * decoupled from hard-coded strings.
 */

export const SITE = {
  name: 'Bohío Kiskeya',
  tagline: 'Maison de la Terre Haïtienne',
  description:
    "Structurer l'agriculture, du champ au marché.",
  url: 'https://bohiokiskeya.com',
};

export const NAV_LINKS = [
  { label: 'Nos origines', path: '/nos-origines' },
  { label: 'Rejoindre le réseau', path: '/rejoindre' },
  { label: 'Devenir partenaire', path: '/partenaire' },
];

export const FOOTER_COLUMNS = [
  // {
  //   heading: 'Topic',
  //   links: [
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //   ],
  // },
  // {
  //   heading: 'Topic',
  //   links: [
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //   ],
  // },
  // {
  //   heading: 'Topic',
  //   links: [
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //     { label: 'Page', path: '#' },
  //   ],
  // },
];

export const SOCIAL_LINKS = {
  facebook: '#',
  instagram: '#',
  linkedin: '#',
  twitter: '#',
};

export const CONTACT_INFO = {
  email: 'info@bohiokiskeya.com',
  phone: '+1 (809) 555-0123',
  address: 'Bas Plateau, Haïti',
};
